import React, { useState } from 'react';
import { Link, linkToRecord, useGetOne } from 'react-admin';
import { ISettings } from '../../../types';
import { SETTINGS_UNIQUE_ENTRY_ID } from '../../settings';

interface ISpeakersRawProps {
  onChange: (spks: string) => void;
}

export const SpeakersRaw = (props: ISpeakersRawProps) => {
  const [speakerRaw, setSpeakerRaw] = useState<string>('');
  const settings = useGetOne<ISettings>('settings', { id: SETTINGS_UNIQUE_ENTRY_ID }).data;
  const nameSeparator = settings?.speakersAutoParser_nameSeparator;

  const onSpeakerRawChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const raw = event.target.value;
    setSpeakerRaw(raw);
    props.onChange(raw);
  };

  const settingsPage = linkToRecord('/settings', 1, 'edit');

  return (
    <>
      <span className="from-group mt-6">
        <label htmlFor="speakerSeparator">
          Utilice '{nameSeparator}' para forzar separcion nombre {nameSeparator} apellido (<Link to={settingsPage}>Cambiar separador</Link>)
        </label>
        <br />
        <textarea className="form-control" value={speakerRaw} onChange={onSpeakerRawChange} rows={15} cols={65} />
      </span>
    </>
  );
};
